import actions from './actions'

export default function InventoryProductInformationsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVENTORYPRODUCTINFORMATION:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVENTORYPRODUCTINFORMATION:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVENTORYPRODUCTINFORMATION:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVENTORYPRODUCTINFORMATION:
      return {
        ...state,
        editing: { inventoryProductInformationID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_INVENTORYPRODUCTINFORMATION_RECIEVED ||
      actions.UPDATE_INVENTORYPRODUCTINFORMATION_RECIEVED ||
      actions.DELETE_INVENTORYPRODUCTINFORMATION_RECIEVED:
      return {
        ...state,
        editing: { inventoryProductInformationID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
